module.exports = __webpack_public_path__ + "ee11d89f8261b2b5b759425545c9220a.obj";